import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'alertContainer']

  static values = {
    maxSizeMb: Number,
    allowedTypes: Array,
  }

  validate(event) {
    const file = event.target.files[0]

    if (!file) {
      this.clearAlert()
      return
    }

    const errors = this.getValidationErrors(file)

    if (errors.length > 0) {
      this.inputTarget.value = ''
      this.showError(errors[0])
      return
    }

    this.showUploading(file)
    this.submitForm()
  }

  getValidationErrors(file) {
    const errors = []
    const maxSizeBytes = this.maxSizeMbValue * 1024 * 1024

    if (file.size > maxSizeBytes) {
      const fileSize = (file.size / 1024 / 1024).toFixed(1)
      errors.push(`File size (${fileSize}MB) exceeds maximum allowed size of ${this.maxSizeMbValue}MB`)
    }
    if (!this.allowedTypesValue.includes(file.type)) {
      errors.push(`File type "${file.type || 'unknown'}" is not allowed. Allowed types: ${this.allowedTypesValue.join(', ')}`)
    }
    return errors
  }

  showError(error) {
    this.clearAlert()

    const alert = document.createElement('div')
    alert.className = 'm-3 mb-0 text-danger text-uppercase sm'
    alert.textContent = error

    this.insertAlert(alert)
  }

  showUploading(file) {
    this.clearAlert()

    const fileSize = (file.size / 1024 / 1024).toFixed(1)
    const alert = document.createElement('div')
    alert.className = 'm-3 mb-0'
    alert.innerHTML = `
      <strong>Uploading:</strong> <span data-file-name></span>
      <div class="spinner-border spinner-border-sm ms-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    `
    // The name is whatever the member's file is called, so it goes in as text, never as markup.
    alert.querySelector('[data-file-name]').textContent = `${file.name} (${fileSize}MB)`

    this.insertAlert(alert)
  }

  insertAlert(alert) {
    this.alertContainerTarget.appendChild(alert)
  }

  submitForm() {
    this.element.requestSubmit()
  }

  clearAlert() {
    this.alertContainerTarget.innerHTML = ''
  }
}
